import axios, { AxiosResponse } from 'axios';
import api from './interceptor';
// Define the type for the token
type Token = string | null;

// Function to create headers with bearer token
export const createHeaders = (token?: Token) => {
	const headers: any = {};
	// If a token is provided, include it in the request headers
	if (token) {
		headers.Authorization = `Bearer ${token}`;
	}
	return headers;
};

//post request export function
export async function POST(url: string, data: any, token?: Token): Promise<AxiosResponse<any>> {
	return api.post(url, data);
}

// post request export function with multipart
export async function POST_MULTIPART(url: string, data: any, token?: Token): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.post(url, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		// const response: AxiosResponse<any> = await api.post(url, data, {
		//     headers: {
		//         ...createHeaders(token),
		//         'Content-Type': 'multipart/form-data'
		//     }
		// });
		return response;
	} catch (error) {
		throw new Error(`Error while making MULTIPART POST request: ${error}`);
	}
}

//get request export function
export async function GET(url: string, token?: Token): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.get(url);
		// const response: AxiosResponse<any> = await api.get(url, { headers: createHeaders(token) });
		return response;
	} catch (error) {
		throw new Error(`Error while making GET request: ${error}`);
	}
}

//put request export function
export async function PUT(url: string, data: any, token?: Token): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.put(url, data);
		// const response: AxiosResponse<any> = await api.put(url, data, { headers: createHeaders(token) });
		return response;
	} catch (error) {
		throw new Error(`Error while making PUT request: ${error}`);
	}
}

//patch request export function
export async function PATCH(url: string, data: any, token?: Token): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.patch(url, data);
		// const response: AxiosResponse<any> = await api.patch(url, data, { headers: createHeaders(token) });
		return response;
	} catch (error) {
		throw new Error(`Error while making PATCH request: ${error}`);
	}
}

// patch request export function with multipart
export async function PATCH_MULTIPART(url: string, data: FormData, token?: Token): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.patch(url, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		// const response: AxiosResponse<any> = await api.patch(url, data, {
		//     headers: {
		//         ...createHeaders(token),
		//         'Content-Type': 'multipart/form-data'
		//     }
		// });
		return response;
	} catch (error) {
		throw new Error(`Error while making PATCH MULTIPART request: ${error}`);
	}
}

//delete request export function
export async function DELETE(url: string, token?: Token, data?: any): Promise<any> {
	try {
		const response: AxiosResponse<any> = await api.delete(url, { data });
		// const response: AxiosResponse<any> = await api.delete(url, { data, headers: createHeaders(token) });
		return response;
	} catch (error) {
		throw new Error(`Error while making DELETE request: ${error}`);
	}
}

// export async function POST(url: string, data: any, token?: Token): Promise<any> {
// 	try {
// 		const response: AxiosResponse<any> = await api.post(url, data);
// 		// const response: AxiosResponse<any> = await api.post(url, data, { headers: createHeaders(token) });
// 		return response;
// 	} catch (error) {
// 		throw new Error(`Error while making POST request: ${error}`);
// 	}
// }
